import { Box, Container, Show, Image } from "@chakra-ui/react";
import React from "react";
import businessMatchingBannerPc from "./assets/business-matching-banner-pc.png";
import businessMatchingBannerSp from "./assets/business-matching-banner-sp.png";

export const BusinessMatchingBanner = () => {
  return (
    <Container maxW="container.lg" px={{ base: 0, md: 6 }} py={{ base: 0, md: 8 }}>
      <Box
        as="a"
        display="block"
        href="https://aloop.jp/static/business_matching?utm_source=web&utm_medium=bmbanner&utm_campaign=260501"
      >
        <Show below="md">
          <Image src={businessMatchingBannerSp} alt="受発注サービス" w="full" />
        </Show>
        <Show above="md">
          <Image src={businessMatchingBannerPc} alt="受発注サービス" w="full" />
        </Show>
      </Box>
    </Container>
  );
};
